<template>
  <!-- -->
  <el-drawer v-model="showDrawer" :title="title" class="mobile-drawer" direction="btt" size="80%" append-to-body :show-close="false">
    <template #header>
      <div class="mobile-drawer-header">
        <div v-if="showTitleBtn" class="cancel" @click="toCancel">{{ cancelText }}</div>
        <div class="header-info">{{ title }}</div>
        <div v-if="showTitleBtn" class="confirm" @click="toConfirm">确认</div>
      </div>
    </template>
    <slot>

    </slot>
  </el-drawer>
</template>

<script>

import {watch} from "vue";

export default {
  emits: ["confirm", "cancel", "update:modelValue"],
  props: {
    title: {default: "选择"},
    modelValue: {default: ""},
    showTitleBtn: {default: true},
    /**
     * 左侧按钮的文案，默认「取消」。
     *
     * ★ 有的抽屉把左侧按钮当别的用：MobileSearchSelect 用它做「清空」——
     *   点遮罩本身就是取消，再留一个取消按钮是多余的。
     *   按钮动作仍走 cancel 事件，由调用方决定做什么。
     */
    cancelText: {default: "取消"},
  },
  name: "MD",
  components: {
  },
  data() {
    return {
      showDrawer: false,
    };
  },
  created() {
    watch(() => this.modelValue, () => this.showDrawer = this.modelValue);
    watch(() => this.showDrawer, () => {
      this.$emit("update:modelValue", this.showDrawer);
    })
  },
  methods: {
    toConfirm() {
      this.$emit("update:modelValue", false);
      this.$emit("confirm");
    },
    toCancel() {
      this.$emit("update:modelValue", false);
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss">
.mobile-drawer-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--el-border-color);
  box-shadow: 0 1px 2px 0 var(--el-box-shadow-color);
  height: 60px;
  .cancel{
    font-size: var(--yq-font-size-small-mobile);
    color: var(--el-color-danger);
  }
  .confirm{
    font-size: var(--yq-font-size-small-mobile);
    color: var(--el-color-success);
  }
  .header-info{
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    font-size: var(--yq-font-size-large-mobile-2);
  }
}
.mobile-drawer{
  font-size: var(--yq-font-size-small-mobile);
  .el-drawer__header{
    padding-top: 0;
  }
  .el-drawer__body{
    padding: 0;
  }
}

</style>